// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__i7cRF","container":"styles_container__uyw8F","footer":"styles_footer__A938F"};